module.exports = __webpack_public_path__ + "static/media/sf-trial-3-correct.8ad4fa55.mp3";